import { ButtonBase, FreedomModal, TypographyBase } from '@fmc-digital/ui';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAbandonedScreenMutation } from '@hooks/useAbandonedScreenMutation';
import { isEmpty } from 'lodash';
export type ExitIntentProps = {
    open: boolean;
    onBackToDashboard?: () => void;
    onContinue: () => void;
};
export const ExitIntent = ({ open, onBackToDashboard, onContinue }: ExitIntentProps) => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const abandonedScreen = useAbandonedScreenMutation(state?.appId);

    const onBack = () => {
        if (!isEmpty(state?.appId) && !isEmpty(state?.bailOutScreen)) {
            let bailout;
            if (typeof state?.bailOutScreen === 'string') {
                bailout = { abandonedScreen: state?.bailOutScreen, haveQuestions: false };
            } else {
                // eslint-disable-next-line @typescript-eslint/ban-types
                bailout = { ...(state?.bailOutScreen as Object), haveQuestions: false };
            }
            abandonedScreen.mutate(bailout);
            navigate('/', { preventScrollReset: true });
        } else if (onBackToDashboard) {
            onBackToDashboard();
        } else {
            navigate('/', { preventScrollReset: true });
        }
    };
    return (
        <FreedomModal
            open={open}
            content={
                [
                    <TypographyBase variant="subtitle2" key="title" data-testid="exit-modal-title">
                        Are you sure you want to leave the application process?
                    </TypographyBase>,
                    <TypographyBase key="content_1" data-testid="exit-modal-content-1">
                        Please note that once you leave, you will not be able to return to your current progress.
                    </TypographyBase>,
                    <TypographyBase key="content_2" data-testid="exit-modal-content-2">
                        Your partial application data has been securely saved. We&apos;re working to process your information and move
                        forward with your application.
                    </TypographyBase>
                ] as Array<React.ReactNode> & string
            }
            actions={[
                <ButtonBase
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={onBack}
                    key="button_1"
                    data-testid="exit-modal-button-1"
                    sx={{
                        textTransform: 'none !important'
                    }}
                >
                    Back to Home
                </ButtonBase>,
                <ButtonBase variant="contained" onClick={onContinue} key="button_2" data-testid="exit-modal-button-2">
                    Continue Application
                </ButtonBase>
            ]}
        />
    );
};
